import { defineComponent as _defineComponent } from 'vue'
import { nextTick, ref, watch } from "vue";

import type { Conversation } from "./types/Conversation";


export default /*#__PURE__*/_defineComponent({
  __name: 'Conversation',
  props: {
    conversation: null
  },
  setup(__props: any) {

const props = __props as {
  conversation: Conversation;
};



const conversationTemplateRef = ref<HTMLDivElement | null>(null);

const scrollToBottom = async () => {
  await nextTick();
  const container = conversationTemplateRef.value?.closest(".conversation-container");

  if (container) {
    container.scroll({
      top: container.scrollHeight,
      behavior: "smooth",
    });
  }
};

watch(
  () => props.conversation.length,
  () => scrollToBottom(),
);

return { __sfc: true,props, conversationTemplateRef, scrollToBottom }
}

})